module.exports = __webpack_public_path__ + "img/consume.37f2e331.png";